import TagsPicker from './TagsPicker';

export default TagsPicker;


// WEBPACK FOOTER //
// ./resources/assets/js/components/TagsPicker/index.js